import {
  Grid,
  Button,
  Typography,
  Paper,

} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import DynamicTable from "./DynamicTable";
import { positionTableHeader } from "./constants";
import { PositionModal } from "../../Imports/ModalImports"
import Services from "../../Services";
import roleManager from "../roles";

const {
  hr
} = Services;


const PositionTable = ({ tableData }) => {

  const [compCodeOptions, setCompCodeOptions] = useState([])
  const [payCodeOptions, setPayCodeOptions] = useState([])
  const [openPosition, setOpenPosition] = useState(false);

  let { data, lists, flag, setFlag, employeeInitialData, employeeDetails } = tableData;


  const [positionInformation, setPositionInformation] = useState({
    employeeId: '',
    fullTitle: '',
    jobCode: '',
    category: '',
    location: '',
    position_level: '',
    subDepartment: '',
    compCode: '',
    payCode: '',
    supervisor: '',
    updatePositon: '',
    id: '',
    JobType: '',
    startDate: null,
    task: null
  })


  const onSubmitPositionData = async (e) => {



    e.preventDefault();
    let data = {
      id: positionInformation?.id,
      full_title: positionInformation?.fullTitle,
      position_level: positionInformation?.positionObj?.id,
      position_category: employeeInitialData?.JobCategoryId,
      location_id: positionInformation?.locationObj?.id,
      Supervisor_Id: positionInformation?.supervisorObj?.id,
      employee_id: employeeDetails?.id,
      start_date: moment(positionInformation?.startDate)
        .format('YYYY-MM-DD')
        .toString(),
      job_code: +positionInformation?.jobCode,
      CompCode: positionInformation?.compCode?.id,
      PayCode: positionInformation?.payCode?.id,
      SubDepartment_Id: positionInformation?.subDepartmentObj?.id,
      JobType: positionInformation?.jobType?.id
    }

    let { task } = positionInformation;
    //      
    // return
    try {
      if (task == 'edit')
        await hr.editPosition(data)
      if (task == 'add')
        await hr.updatePosition(data)
      setFlag(!flag)
      setOpenPosition(false)
    }
    catch (exc) {

    }
  }

  const getCompCode = async () => {
    let res = await hr.onUpdateCompCodeList()
    setCompCodeOptions(res?.data)
  }

  const getPayCode = async () => {
    let res = await hr.onUpdatePayCodeList()
    setPayCodeOptions(res?.data)
  }

  useEffect(() => {

    getCompCode()
    getPayCode()

  }, []);

  const onEditClick = (type, row) => {

    if (type == 1)
      setPositionInformation({
        id: row.id,
        employeeId: row?.employeeDetails?.id,
        fullTitle: row?.FullTitle,
        category: row?.JobCategoryId,
        location: row.TGSLocation?.name,
        locationID: row.TGSLocation.id,
        subDepartment: row?.SubDepartment?.name,
        subDepartmentId: row.SubDepartment.id,
        supervisor: row.Employee.firstName + " " + row.Employee.lastName,
        Supervisor_Id: row.SupervisorId,
        SupervisorId: row.SupervisorId,
        startDate: new Date(row.EffectiveDate),
        jobCode: row.JobCode,
        positionObj: { name: row?.EmployeeLevel?.name, id: row?.EmployeeLevel?.id },
        locationObj: { id: row.TGSLocation.id, title: row.TGSLocation.name },
        supervisorObj: { id: row?.Employee?.id, name: row?.Employee?.firstName + " " + row?.Employee?.lastName },
        subDepartmentObj: { id: row.SubDepartment.id, title: row?.SubDepartment?.name },
        jobType: { id: row?.JobType, name: row?.JobType },
        compCode: compCodeOptions.filter(obj => obj.id == row?.CompCode)[0],
        payCode: payCodeOptions.filter(obj => obj.id == row?.PayCode)[0],
        task: 'edit'
      })
    if (type == 2)
      setPositionInformation({ task: 'add' })

    setOpenPosition(true)
  }


  // let table = {
  //   header: positionTableHeader,
  //   rows: data?.map(row => [
  //     row.FullTitle,
  //     row.EmployeeLevel?.name,
  //     row.TGSLocation?.name,
  //     row.CompCode,
  //     row.JobCode,
  //     row.SubDepartment.name,
  //     row.PayCode,
  //     row?.Employee?.firstName + " " + row?.Employee?.lastName,
  //     moment(row.EffectiveDate).utc().format('MM-DD-YYYY'),

  //     <Button onClick={() => onEditClick(1, row)} className="EditIcon"></Button>
  //   ])
  // }
  let table = {
    header: positionTableHeader,
    rows: data?.map(row => [
      row.FullTitle,
      row.EmployeeLevel?.name,
      row.TGSLocation?.name,
      row.CompCode,
      row.JobCode,
      row.SubDepartment.name,
      row.PayCode,
      row?.Employee?.firstName + " " + row?.Employee?.lastName,
      moment(row.EffectiveDate).utc().format('MM-DD-YYYY'),
      roleManager("employeeLookup", "sections", "positionButton") && (
        <Button onClick={() => onEditClick(1, row)} className="EditIcon"></Button>
      )
    ])
  };



  let positionModalData = {
    employeeDetails: employeeDetails,
    open: openPosition,
    close: () => setOpenPosition(false),
    submitForm: onSubmitPositionData,
    positionData: positionInformation,
    changePositionData: setPositionInformation,
    listData: lists,
    payCodelist: payCodeOptions,
    compCodelist: compCodeOptions,
  }
  return (

    <Grid xs={12} className="">
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={9} style={{marginBottom:'10px'}}>
        {roleManager("employeeLookup", "sections", "positionButton") && (
            <Button className="LinkButton" onClick={() => onEditClick(2)}>Add new position</Button>
          )}
        </Grid>
      
      </Grid>

      <Paper>

      </Paper>
      <Grid xs={12} >
        <DynamicTable tableData={table} />

      </Grid>
      <PositionModal modalData={positionModalData} />

    </Grid>



  )
}

export default PositionTable